// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  font-size: 0.875rem;
  border-radius: 0.25rem;
}
.btn.h-custom-36 {
  padding: 0.3rem 0.75rem;
}
.btn.small {
  font-size: 0.875em;
}
.btn.btn-primary {
  background: var(--primary-600);
  border-color: var(--primary-600);
  color: var(--black);
}
.btn.btn-primary:hover:enabled {
  background: var(--yellow-600);
  border-color: var(--yellow-600);
  color: var(--black);
}
.btn.btn-primary:active:enabled {
  background: var(--yellow-800);
  border-color: var(--yellow-800);
  color: var(--black);
}
.btn.btn-outline-primary {
  background: var(--purpleCircleBtn);
  border-color: var(--primaryHover);
  color: var(--white);
}
.btn.btn-outline-primary:hover {
  background: var(--primaryGradient);
  border-color: transparent;
  background-origin: border-box;
}
.btn.btn-secondary {
  background: var(--dice-neutral-400);
  border: 0;
  color: var(--white);
}
.btn.btn-secondary:hover {
  background: var(--dice-neutral-300);
}
.btn.btn-success {
  border: 2px solid var(--greenChecked);
  background: var(--greenChecked);
  font-weight: 500;
}
.btn.btn-success:hover {
  border-color: var(--greenChecked);
  background: var(--greenChecked);
  opacity: 0.9;
}
.btn.btn-static {
  border: 2px solid var(--primary);
  background: transparent;
}
.btn.btn-static:hover {
  border: 2px solid var(--primary);
  background: transparent;
}
.btn.btn-outline-white {
  color: var(--white);
  border: 1px solid var(--white);
  background: var(--black);
}
.btn.btn-outline-white:hover {
  border-color: var(--white);
  background: var(--white);
  color: var(--zinc-950);
}
.btn.btn-outline-secondary {
  color: var(--white);
  border: 2px solid var(--primary);
  background: var(--black);
}
.btn.btn-outline-secondary:hover {
  border-color: var(--secondary);
  background: var(--primaryHover);
}
.btn.btn-outline-warning {
  color: var(--yellow-700);
  border: 1px solid var(--yellow-700);
  background: var(--black);
}
.btn.btn-outline-warning:hover {
  border-color: var(--yellow-700);
  background: var(--yellow-900);
  color: var(--yellow-700);
}
.btn.btn-outline-warning:is(:active, .active):enabled {
  background: var(--yellow-700);
  border-color: var(--yellow-700);
  color: var(--zinc-950);
}
.btn.btn-outline-orange {
  color: var(--orange-350);
  border: 1px solid var(--orange-350);
  background: var(--black);
}
.btn.btn-outline-orange:hover {
  border-color: var(--orange-350);
  background: var(--orange-900);
  color: var(--orange-350);
}
.btn.btn-outline-orange:is(:active, .active):enabled {
  background: var(--orange-350);
  border-color: var(--orange-350);
  color: var(--zinc-950);
}
.btn.btn-outline-danger {
  color: var(--pink-300);
  border: 1px solid var(--pink-300);
  background: var(--black);
}
.btn.btn-outline-danger:hover {
  border-color: var(--pink-300);
  background: var(--red-900);
  color: var(--pink-300);
}
.btn.btn-outline-danger:is(:active, .active):enabled {
  background: var(--pink-300);
  border-color: var(--pink-300);
  color: var(--zinc-950);
}
.btn.btn-outline-info {
  color: var(--cyan-400);
  border: 1px solid var(--cyan-400);
  background: var(--black);
}
.btn.btn-outline-info:hover {
  border-color: var(--cyan-400);
  background: var(--cyan-900);
  color: var(--cyan-400);
}
.btn.btn-outline-info:is(:active, .active):enabled {
  background: var(--cyan-400);
  border-color: var(--cyan-400);
  color: var(--zinc-950);
}
.btn:disabled {
  cursor: not-allowed;
  pointer-events: all;
}
.btn:disabled:hover {
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/components/ui-kit/Button/Button.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,sBAAA;AACF;AAAE;EACE,uBAAA;AAEJ;AAAE;EACE,kBAAA;AAEJ;AAAE;EACE,8BAAA;EACA,gCAAA;EACA,mBAAA;AAEJ;AADI;EACE,6BAAA;EACA,+BAAA;EACA,mBAAA;AAGN;AADI;EACE,6BAAA;EACA,+BAAA;EACA,mBAAA;AAGN;AAAE;EACE,kCAAA;EACA,iCAAA;EACA,mBAAA;AAEJ;AADI;EACE,kCAAA;EACA,yBAAA;EACA,6BAAA;AAGN;AAAE;EACE,mCAAA;EACA,SAAA;EACA,mBAAA;AAEJ;AADI;EACE,mCAAA;AAGN;AAAE;EACE,qCAAA;EACA,+BAAA;EACA,gBAAA;AAEJ;AADI;EACE,iCAAA;EACA,+BAAA;EACA,YAAA;AAGN;AAAE;EACE,gCAAA;EACA,uBAAA;AAEJ;AADI;EACE,gCAAA;EACA,uBAAA;AAGN;AAAE;EACE,mBAAA;EACA,8BAAA;EACA,wBAAA;AAEJ;AADI;EACE,0BAAA;EACA,wBAAA;EACA,sBAAA;AAGN;AAAE;EACE,mBAAA;EACA,gCAAA;EACA,wBAAA;AAEJ;AADI;EACE,8BAAA;EACA,+BAAA;AAGN;AAAE;EACE,wBAAA;EACA,mCAAA;EACA,wBAAA;AAEJ;AADI;EACE,+BAAA;EACA,6BAAA;EACA,wBAAA;AAGN;AADI;EACE,6BAAA;EACA,+BAAA;EACA,sBAAA;AAGN;AAAE;EACE,wBAAA;EACA,mCAAA;EACA,wBAAA;AAEJ;AADI;EACE,+BAAA;EACA,6BAAA;EACA,wBAAA;AAGN;AADI;EACE,6BAAA;EACA,+BAAA;EACA,sBAAA;AAGN;AAAE;EACE,sBAAA;EACA,iCAAA;EACA,wBAAA;AAEJ;AADI;EACE,6BAAA;EACA,0BAAA;EACA,sBAAA;AAGN;AADI;EACE,2BAAA;EACA,6BAAA;EACA,sBAAA;AAGN;AAAE;EACE,sBAAA;EACA,iCAAA;EACA,wBAAA;AAEJ;AADI;EACE,6BAAA;EACA,2BAAA;EACA,sBAAA;AAGN;AADI;EACE,2BAAA;EACA,6BAAA;EACA,sBAAA;AAGN;AAAE;EACE,mBAAA;EACA,mBAAA;AAEJ;AADI;EACE,YAAA;AAGN","sourcesContent":[".btn {\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n  &.h-custom-36 {\n    padding: 0.3rem 0.75rem;\n  }\n  &.small {\n    font-size:.875em\n  }\n  &.btn-primary {\n    background: var(--primary-600);\n    border-color: var(--primary-600);\n    color: var(--black);\n    &:hover:enabled {\n      background: var(--yellow-600);\n      border-color: var(--yellow-600);\n      color: var(--black);\n    }\n    &:active:enabled {\n      background: var(--yellow-800);\n      border-color: var(--yellow-800);\n      color: var(--black);\n    }\n  }\n  &.btn-outline-primary {\n    background: var(--purpleCircleBtn);\n    border-color: var(--primaryHover);\n    color: var(--white);\n    &:hover {\n      background: var(--primaryGradient);\n      border-color: transparent;\n      background-origin: border-box;\n    }\n  }\n  &.btn-secondary {\n    background: var(--dice-neutral-400);\n    border: 0;\n    color: var(--white);\n    &:hover {\n      background: var(--dice-neutral-300);\n    }\n  }\n  &.btn-success {\n    border: 2px solid var(--greenChecked);\n    background: var(--greenChecked);\n    font-weight: 500;\n    &:hover {\n      border-color: var(--greenChecked);\n      background: var(--greenChecked);\n      opacity: 0.9;\n    }\n  }\n  &.btn-static {\n    border: 2px solid var(--primary);\n    background: transparent;\n    &:hover {\n      border: 2px solid var(--primary);\n      background: transparent;\n    }\n  }\n  &.btn-outline-white {\n    color: var(--white);\n    border: 1px solid var(--white);\n    background: var(--black);\n    &:hover {\n      border-color: var(--white);\n      background: var(--white);\n      color: var(--zinc-950);\n    }\n  }\n  &.btn-outline-secondary {\n    color: var(--white);\n    border: 2px solid var(--primary);\n    background: var(--black);\n    &:hover {\n      border-color: var(--secondary);\n      background: var(--primaryHover);\n    }\n  }\n  &.btn-outline-warning{\n    color: var(--yellow-700);\n    border: 1px solid var(--yellow-700);\n    background: var(--black);\n    &:hover {\n      border-color: var(--yellow-700);\n      background: var(--yellow-900);\n      color: var(--yellow-700);\n    }\n    &:is(:active, .active):enabled {\n      background: var(--yellow-700);\n      border-color: var(--yellow-700);\n      color: var(--zinc-950);\n    }\n  }\n  &.btn-outline-orange {\n    color: var(--orange-350);\n    border: 1px solid var(--orange-350);\n    background: var(--black);\n    &:hover {\n      border-color: var(--orange-350);\n      background: var(--orange-900);\n      color: var(--orange-350);\n    }\n    &:is(:active, .active):enabled {\n      background: var(--orange-350);\n      border-color: var(--orange-350);\n      color: var(--zinc-950);\n    }\n  }\n  &.btn-outline-danger {\n    color: var(--pink-300);\n    border: 1px solid var(--pink-300);\n    background: var(--black);\n    &:hover {\n      border-color: var(--pink-300);\n      background: var(--red-900);\n      color: var(--pink-300);\n    }\n    &:is(:active, .active):enabled {\n      background: var(--pink-300);\n      border-color: var(--pink-300);\n      color: var(--zinc-950);\n    }\n  }\n  &.btn-outline-info {\n    color: var(--cyan-400);\n    border: 1px solid var(--cyan-400);\n    background: var(--black);\n    &:hover {\n      border-color: var(--cyan-400);\n      background: var(--cyan-900);\n      color: var(--cyan-400);\n    }\n    &:is(:active, .active):enabled {\n      background: var(--cyan-400);\n      border-color: var(--cyan-400);\n      color: var(--zinc-950);\n    }\n  }\n  &:disabled {\n    cursor: not-allowed;\n    pointer-events: all;\n    &:hover {\n      opacity: 0.6;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
